// extracted by mini-css-extract-plugin
export default {"container":"UserMessage-module__container--cAvvK"};